module.exports = __webpack_public_path__ + "img/revenue-goal.5191514f.svg";